import { useMutation } from "@tanstack/react-query";
import axiosInstance from "../../../constants/axiosInstance";

interface TriggerAlarmPayload {
  plantId: string;
}

const triggerPlantAlarm = async ({ plantId }: TriggerAlarmPayload): Promise<any> => {
  const { data } = await axiosInstance().post('/biDirectionalControl/createAndProcessTrigger', {
    assetId: plantId,
    controlValue: '1',
  });
  return data;
};

export const useTriggerPlantAlarm = () => {
  const { mutate, isPending, isSuccess, isError, error } = useMutation({
    mutationFn: (payload: TriggerAlarmPayload) => triggerPlantAlarm(payload),
  });

  return {
    triggerAlarm: mutate,
    isTriggering: isPending,
    isSuccess,
    isError,
    error,
  };
};
